import {AbstractOption} from './abstract-option';
import {EssentialOptionData} from './types/essential-option-data';
import {EssentialGroup} from './essential-group';
import {Logger} from './utilities/logger';
import {A11yConsentApi} from './a11y-consent-api';

/**
 * Essential consent option, meaning it cannot be enabled and/or disabled by the user.
 *
 * @author Philipp Seiler <sep@earlybird.at>
 */
export class EssentialOption extends AbstractOption {
  public group: EssentialGroup;

  constructor(api: A11yConsentApi, group: EssentialGroup, data: EssentialOptionData) {
    super(api, group, data);
    Logger.debug('essential-option', `Starting to construct "${this.uid}".`);

    this.group = group;

    Logger.debug('essential-option', `Finished constructing "${this.uid}".`);
  }
}
